import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { CMSPortalService } from '../shared/service/cms-portal.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';

import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { Observable } from 'rxjs/Observable';
import { ResultadoPesquisa } from '../shared/model/pesquisa.models';
import { Evento } from '../shared/model/evento.model';

@Component({
  selector: 'app-pesquisa',
  templateUrl: './pesquisa.component.html',
  styleUrls: ['./pesquisa.component.css']
})
export class PesquisaComponent implements OnInit {

  @ViewChild('Pesquisa') pesquisaEL: ElementRef;
  resultados: ResultadoPesquisa[];
  resultados_original: ResultadoPesquisa[];
  eventoSelecionado: Evento;
  searchForm: FormGroup;
  searchControl: FormControl;

  constructor(private service: CMSPortalService,
              private route: ActivatedRoute,
              private router: Router,
              private fb: FormBuilder) { }

  ngOnInit() {

    this.searchControl = this.fb.control('');
    this.searchForm = this.fb.group({
      searchControl: this.searchControl
    });

    this.searchControl.valueChanges
        .debounceTime(500)
        .distinctUntilChanged()
        .switchMap(searchTerm => this.service.realizarPesquisa(searchTerm))
        .subscribe(res => {
          this.resultados = res.conteudo;
          this.resultados_original = this.resultados;
        });

    this.route.params.subscribe(params => {
      this.searchControl.setValue(params['texto']);
      this.efetuarPesquisa(params['texto']);
    });
  }

  efetuarPesquisa(pesquisa: string) {
    this.service.realizarPesquisa(pesquisa).subscribe(res => {
      this.resultados = res.conteudo;
      this.resultados_original = this.resultados;
    });
  }

  realizarPesquisa(pesquisa) {
    this.service.realizarPesquisa(pesquisa.searchControl).subscribe(res => {
      this.resultados = res.conteudo;
      this.resultados_original = this.resultados;
    });
  }

  carregarIcone(resultado: ResultadoPesquisa): string {
    if (resultado.tipo === 'Eventos') {
      return 'fa fa-calendar';
    } else if (resultado.tipo === 'Notícias') {
      return 'fa fa-newspaper-o';
    } else if (resultado.tipo === 'Vídeos') {
      return 'fa fa-video-camera';
    }
    return '';
  }

  filtrarPesquisa(filtro: string) {
    if (filtro === '') {
      this.resultados = this.resultados_original;
    } else {
      this.resultados = this.resultados_original.filter(r => r.tipo === filtro);
    }
  }

  abrirItem(resultado: ResultadoPesquisa) {
    if (resultado.tipo === 'Eventos') {

    } else if (resultado.tipo === 'Notícias') {
      this.router.navigate(['/noticia', resultado.id]);
    } else if (resultado.tipo === 'Vídeos') {
      this.router.navigate(['/video', resultado.id]);
    }
  }

}
